import Popper from "@mui/material/Popper";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import TransparentButton from "../TransparentButton/TransparentButton";
import {useTheme} from "../../../contexts/theme";

interface StyledPopperProps {
    message: string;
    open: boolean;
    anchorEl: null | HTMLElement
    id:string;
    afterResponse: (message: string) => void;
}

const StyledPopper: React.FC<StyledPopperProps> = ({message, anchorEl, afterResponse, open, id}) => {
    const theme = useTheme();
    return (
        <Popper
            id={id}
            open={open}
            anchorEl={anchorEl}
            sx={{
                border: `${theme.border.width.medium} ${theme.border.type.solid} ${theme.palette.white}`,
                borderRadius: theme.border.radius.md,
                padding: theme.spacing.md,
                backgroundColor: theme.palette.black,
                zIndex: 2
            }}>
            <Typography sx={{color: theme.palette.white}}>{message}</Typography>
            <Box sx={{paddingTop: theme.spacing.xs}} display="flex" justifyContent="space-around">
                <TransparentButton text={'YES'} onClick={() => afterResponse('YES')}/>
                <TransparentButton text={'NO'} onClick={() => afterResponse('NO')}/>
            </Box>
        </Popper>
    )
}

export default StyledPopper